import { breadcrumbScript } from "@/lib/seo-jsonld";
import { createFileRoute, Link } from "@tanstack/react-router";
import { HelpCircle, MessageCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { FAQ, waLink } from "@/lib/contact";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "Tez-tez verilən suallar — Albazar.az" },
      {
        name: "description",
        content:
          "Albazar.az haqqında ən çox verilən suallar: elan yerləşdirmə, VIP/Premium qiymətlər, balans, moderasiya və dəstək.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:title", content: "Tez-tez verilən suallar — Albazar.az" },
      {
        property: "og:description",
        content: "Elan, balans, VIP/Premium və dəstək ilə bağlı bütün cavablar.",
      },
      { property: "og:url", content: "https://albazar.az/faq" },
    ],
    links: [{ rel: "canonical", href: "https://albazar.az/faq" }],
    scripts: [
      breadcrumbScript([{ name: "Tez-tez verilən suallar", path: "/faq" }]),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <div className="container-x max-w-3xl py-10">
      <div className="flex items-center gap-3">
        <span className="grid size-11 place-items-center rounded-2xl bg-primary/10 text-primary">
          <HelpCircle className="size-5" />
        </span>
        <h1 className="text-3xl font-extrabold tracking-tight">Tez-tez verilən suallar</h1>
      </div>
      <p className="mt-3 text-sm text-muted-foreground">
        Ən çox soruşulan sualların cavabları. Axtardığınızı tapmadınız? Dəstək xidmətinə yazın.
      </p>

      <Accordion type="single" collapsible className="mt-6 space-y-3">
        {FAQ.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`i${i}`}
            className="rounded-2xl border border-border bg-card px-4 shadow-card"
          >
            <AccordionTrigger className="text-left text-sm font-bold hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-8 flex flex-col gap-3 rounded-3xl border border-border bg-card p-5 shadow-card sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm font-semibold">Sualınıza cavab tapmadınız?</p>
        <div className="flex gap-2">
          <Button asChild className="h-10 rounded-2xl">
            <a href={waLink("Salam, sualım var")} target="_blank" rel="noreferrer">
              <MessageCircle className="mr-1 size-4" /> WhatsApp ilə yaz
            </a>
          </Button>
          <Button asChild variant="outline" className="h-10 rounded-2xl">
            <Link to="/elaqe">Əlaqə səhifəsi</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
